import {WeatherStationFromList} from '@smartmixin/core';
import React from 'react';
import {
  getDefaultChannelName,
  resolveGivenSensorName,
} from '../utils/SensorNames';

const useSensorNames = (station: WeatherStationFromList) => {
  const getGivenChannelName = React.useCallback(
    (metric: string) =>
      resolveGivenSensorName(metric, station?.meta?.sensor_names),
    [station?.meta?.sensor_names],
  );

  const getChannelName = React.useCallback(
    (metric: string) => {
      const sensorName = getGivenChannelName(metric);
      if (sensorName) {
        return sensorName;
      }

      return getDefaultChannelName(metric);
    },
    [getGivenChannelName],
  );

  return {getDefaultChannelName, getGivenChannelName, getChannelName};
};

export default useSensorNames;
